import React from "react";

function Error() {
  return <div>Error 404 not found</div>;
}

export default Error;
